export function bikeDetail() {
    $(".specs-mobile-title").click(function () {
        $(this).parent().toggleClass('active');
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/bikeDetail.js